class Favorite {

    #favorites
    #tag

    constructor(tag) {
        this.#tag = tag;
        this.#favorites = JSON.parse(localStorage.getItem(this.#tag)) || [];
    }

    getFavorites() {
        return this.#favorites;
    }

    refreshFavorites() {
        if (localStorage.getItem(this.#tag) !== null) {
            this.#favorites = JSON.parse(localStorage.getItem(this.#tag));
        }
    }

    setFavorites() {
        localStorage.setItem(this.#tag, JSON.stringify(this.#favorites));
        window.dispatchEvent(new CustomEvent('favoritescountupdated', { detail: this.getFavorites().length }));
    }

    toggleFavorite(fav) {
        const checkId = (obj) =>
            obj.id === fav.id && obj.typology === fav.typology;
        this.refreshFavorites();
        if (this.#favorites.some(checkId)) {
            this.#favorites.splice(this.#favorites.findIndex(checkId), 1);
        } else {
            this.#favorites.push(fav);
        }
        this.setFavorites();
    }
}

export default Favorite;
